import type { FC } from 'react';

import { colorsPalettes } from '@similarweb/styles';

import { formatPercentage } from '../../services/numberFormat';

import { StyledArrowIcon, StyledChangeValue, StyledTrafficChangeIndicator } from './styles';

export type TrafficChangeIndicatorProps = {
  change: number;
  greaterIsBetter?: boolean;
};

export const TrafficChangeIndicator: FC<TrafficChangeIndicatorProps> = ({ change, greaterIsBetter = true }) => {
  if (!change) {
    return <StyledTrafficChangeIndicator></StyledTrafficChangeIndicator>;
  }
  const isBetter = change > 0 === greaterIsBetter;
  return (
    <StyledTrafficChangeIndicator>
      <StyledArrowIcon
        iconName={change > 0 ? 'arrow-up-grey' : 'arrow-down-grey'}
        iconColor={isBetter ? colorsPalettes.green.s100 : colorsPalettes.red.s100}
        size="xs"
      />
      <StyledChangeValue variant={isBetter ? 'green' : 'red'}>
        {formatPercentage(Math.abs(change), 2)}
      </StyledChangeValue>
    </StyledTrafficChangeIndicator>
  );
};
